import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-section-create",
  templateUrl: "./section-create.component.html",
  styleUrls: ["./section-create.component.scss"],
})
export class SectionCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public sectionForm: FormGroup;
  public pages = [];

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      console.log(`${id}`);
      this.http
        .get<any>(this.api_endpoint + "/sectionsbyid/" + `${id}`)
        .subscribe(
          (data) => {
            if (data.data != null) {
              this.action = "Update";
              this.sectionForm.patchValue({
                _id: data.data._id,
                heading: data.data.heading,
                description: data.data.description,
                page: data.data.page,
                pdf: data.data.pdf,
                gallery_title: data.data.gallery_title,
                gallery: data.data.gallery,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.sectionForm = this.formBuilder.group({
      heading: ["", Validators.required],
      description: ["", Validators.required],
      page: ["", Validators.required],
      pdf: [""],
      gallery_title: [""],
      gallery: [""],
      _id: [""],
    });
    this.http.get<any>(this.api_endpoint + "/pages/").subscribe(
      (data) => {
        this.pages = data.data;
        // console.log(this.pages);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  get f() {
    return this.sectionForm.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.sectionForm.invalid) {
      return;
    }

    if (this.action == "Submit") {
      var data = {
        heading: this.sectionForm.value.heading,
        description: this.sectionForm.value.description,
        page: this.sectionForm.value.page,
        pdf: this.sectionForm.value.pdf,
        gallery_title: this.sectionForm.value.gallery_title,
        gallery: this.sectionForm.value.gallery,
        admin: sessionStorage.getItem("adminName"),
      };
      console.log(data);
      this.http.post<any>(this.api_endpoint + "/sections", data).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/sections/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    } else {
      var data1 = {
        heading: this.sectionForm.value.heading,
        description: this.sectionForm.value.description,
        page: this.sectionForm.value.page,
        pdf: this.sectionForm.value.pdf,
        gallery_title: this.sectionForm.value.gallery_title,
        gallery: this.sectionForm.value.gallery,
        admin: sessionStorage.getItem("adminName"),
        _id: this.sectionForm.value._id,
      };
      console.log(data1);
      this.http.put<any>(this.api_endpoint + "/sections/", data1).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/sections/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
